import { QueryClient } from "@tanstack/react-query";

/**
 * TanStack Query singleton client.
 *
 * Defaults Phase 8A:
 * - staleTime 30s → list views revalidate sensatamente senza flickkerare;
 * - retry 1 → un solo retry su transient (5xx); 4xx non viene mai re-tentato;
 * - refetchOnWindowFocus disabilitato → admin tool, niente refresh ad ogni
 *   tab-switch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (failureCount >= 1) return false;
        if (error instanceof Response && error.status >= 400 && error.status < 500) {
          return false;
        }
        return true;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
